enum ROLES {
  ROLE_USER = 'ROLE_USER',
  ROLE_HR = 'ROLE_HR',
  ROLE_SELLER = 'ROLE_SELLER',
  ROLE_LECTURER = 'ROLE_LECTURER',
  ROLE_MENTOR = 'ROLE_MENTOR',
  ROLE_CS = 'ROLE_CS',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}

export default ROLES;
